import { useMemo } from "react";
import { ConductStatuses } from "~enums/conductStatuses.ts";
import { sortStringValues } from "~utils/utilities.ts";

export const useGetConductStatusOptions = () => {
  return useMemo(
    () =>
      Object.values(ConductStatuses)
        .sort(sortStringValues)
        .map((item) => ({ label: item, value: item })),
    [],
  );
};
